// Universal theme color tokens, the same set and names web_check-in uses (its src/theme/theme.types.ts),
// so a hotel's `webapptheme.colors` drives every app the same way. Values are "R G B" triplets.
//
// DEFAULT_COLORS is the Shashi theme (web_check-in's SHASHI_THEME), used for any token the hotel's
// webapptheme doesn't set. CommonJS so tailwind.config.js can require it too.

const DEFAULT_COLORS = {
  primary: "10 10 10",
  primaryHover: "38 38 38",
  onPrimary: "255 255 255",
  secondary: "255 0 154",
  onSecondary: "255 255 255",
  accent: "255 0 154",
  accentHover: "255 0 154",
  accentStrong: "255 0 154",
  onAccent: "255 255 255",
  accentBg: "255 237 248",
  accentText: "255 0 154",
  textPrimary: "20 20 20",
  textSecondary: "94 94 94",
  textMuted: "154 154 154",
  surface: "255 255 255",
  surfacePage: "245 245 244",
  surfaceSunken: "236 236 236",
  border: "228 228 228",
  borderStrong: "203 203 203",
  navBg: "12 12 12",
  navActive: "255 0 154",
  navInactive: "184 184 184",
  success: "29 158 117",
  successBg: "225 245 238",
  danger: "226 75 74",
  dangerBg: "252 235 235",
  warning: "239 159 39",
  disabled: "201 201 201",
  background: "248 248 248",
  statusAccent: "255 0 154",
};

// webapptheme.radius, as CSS lengths (Tailwind rounded-button, rounded-card, ...).
const DEFAULT_RADIUS = {
  button: "0px",
  card: "0px",
  input: "4px",
  chip: "10px",
  sheetTop: "0px",
};

const DEFAULT_FONT_FAMILY = '"Azo Sans", sans-serif';

/** textSecondary -> "text-secondary" (Tailwind token name, CSS variable suffix). */
const toTokenName = (key) => key.replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`);

/** textSecondary -> "--color-text-secondary" */
const toCssVar = (key) => `--color-${toTokenName(key)}`;

/** sheetTop -> "--radius-sheet-top" */
const toRadiusVar = (key) => `--radius-${toTokenName(key)}`;

module.exports = {
  DEFAULT_COLORS,
  DEFAULT_RADIUS,
  DEFAULT_FONT_FAMILY,
  toTokenName,
  toCssVar,
  toRadiusVar,
};
